import { useEffect, useState } from "react";

import {
  getRateLimitRemainingSeconds,
  isRateLimitCoolingDown,
  RATE_LIMIT_EVENT,
  type RateLimitActionKey,
} from "../utils/httpRateLimit";

/** Re-renders while a rate-limit cooldown is active for the given action. */
export function useRateLimitCooldown(actionKey: RateLimitActionKey): {
  isCoolingDown: boolean;
  retryAfterSeconds: number;
} {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const bump = () => setTick((n) => n + 1);
    window.addEventListener(RATE_LIMIT_EVENT, bump);
    const interval = window.setInterval(bump, 1000);
    return () => {
      window.removeEventListener(RATE_LIMIT_EVENT, bump);
      window.clearInterval(interval);
    };
  }, []);

  void tick;

  return {
    isCoolingDown: isRateLimitCoolingDown(actionKey),
    retryAfterSeconds: getRateLimitRemainingSeconds(actionKey),
  };
}
